<template>
  <!-- Order Quality Score: Zahl + farbiger Balken; im Mouseover die zwoelf Teilscores je Bereich -->
  <div class="oqs-cell-wrap">
    <div class="oqs-cell-score">
      <span class="oqs-cell-big">{{ fmt(row.oqs, 1) }}</span>
      <span class="oqs-cell-small">/ 100</span>
    </div>
    <div class="oqs-bar"><div class="oqs-bar-fill" :class="colorClass(row.oqs)" :style="{ width: clamp(row.oqs) + '%' }"></div></div>
    <md-tooltip md-direction="right" class="oqs-tooltip">
      <div class="oqs-tip-head">
        <span class="oqs-tip-label">{{ $t("procurement.oqs.calculated") }}</span>
        <span><strong class="oqs-tip-big">{{ fmt(row.oqs, 1) }}</strong> / 100</span>
      </div>
      <div class="oqs-bar oqs-bar--large"><div class="oqs-bar-fill" :class="colorClass(row.oqs)" :style="{ width: clamp(row.oqs) + '%' }"></div></div>
      <table class="oqs-tip-table">
        <template v-for="area in areas">
          <tr :key="area" class="oqs-tip-area">
            <td colspan="3">{{ $t("oqsSettings.areas." + area) }}</td>
            <td class="oqs-tip-num">{{ fmt(areaPoints(area), 1) }} / {{ fmt(areaWeight(area), 0) }} P.</td>
          </tr>
          <tr v-for="p in partsOf(area)" :key="p.key">
            <td class="oqs-tip-name">{{ $t("oqsSettings.keys." + p.key) }}</td>
            <td class="oqs-tip-value">{{ valueText(p) }}</td>
            <td class="oqs-tip-barcell">
              <div class="oqs-bar oqs-bar--part"><div class="oqs-bar-fill oqs-bar-fill--part" :style="{ width: clamp(p.score) + '%' }"></div></div>
              <span class="oqs-tip-score">{{ fmt(p.score, 1) }}</span>
            </td>
            <td class="oqs-tip-num">+{{ fmt(p.points, 1) }} <span class="oqs-tip-weight">({{ fmt(p.weight, 1) }} %)</span></td>
          </tr>
        </template>
      </table>
    </md-tooltip>
  </div>
</template>
<script>
const AREAS = ["sales", "range", "margin"];

export default {
  name: "OqsCell",
  props: {
    row: { type: Object, required: true },
  },
  data() {
    return { areas: AREAS };
  },
  methods: {
    partsOf(area) {
      return (this.row.oqsParts || []).filter((p) => p.area === area);
    },
    areaPoints(area) {
      return this.partsOf(area).reduce((s, p) => s + p.points, 0);
    },
    areaWeight(area) {
      return this.partsOf(area).reduce((s, p) => s + p.weight, 0);
    },
    clamp(v) {
      return Math.max(0, Math.min(100, Number(v) || 0));
    },
    // grau 0-20, rot 20-40, orange 40-60, gelb 60-80, gruen 80-100 (Kundenvorgabe OQS.xlsx)
    colorClass(v) {
      const n = Number(v) || 0;
      if (n >= 80) return "oqs-green";
      if (n >= 60) return "oqs-yellow";
      if (n >= 40) return "oqs-orange";
      if (n >= 20) return "oqs-red";
      return "oqs-grey";
    },
    valueText(p) {
      if (p.value == null) return "–";
      if (p.key.startsWith("Sales")) return `${this.fmt(p.value, 0)} ${this.$t("oqsSettings.units.pieces")}`;
      if (p.key.startsWith("Range")) return `${this.fmt(p.value, 1)} ${this.$t("oqsSettings.units.months")}`;
      return p.key.endsWith("Percent") ? `${this.fmt(p.value, 1)} %` : `${this.fmt(p.value, 2)} €`;
    },
    fmt(value, decimals) {
      return this.$options.filters.formatNumberGerman(value, decimals);
    },
  },
};
</script>
<style>
.oqs-cell-wrap {
  min-width: 78px;
  cursor: default;
}
.oqs-cell-score {
  white-space: nowrap;
}
.oqs-cell-big {
  font-size: 18px;
  font-weight: 700;
  color: #333;
}
.oqs-cell-small {
  font-size: 11px;
  color: #888;
  margin-left: 2px;
}
.oqs-bar {
  height: 6px;
  border-radius: 3px;
  background: #eee;
  overflow: hidden;
  margin-top: 3px;
}
.oqs-bar--large {
  height: 8px;
  margin: 6px 0 10px;
}
.oqs-bar--part {
  height: 6px;
  margin: 0;
  flex: 1;
}
.oqs-bar-fill {
  height: 100%;
  border-radius: 3px;
}
.oqs-bar-fill--part {
  background: #5b8fc9;
}
.oqs-grey {
  background: #bdbdbd;
}
.oqs-red {
  background: #e57373;
}
.oqs-orange {
  background: #ffa726;
}
.oqs-yellow {
  background: #f2cf4a;
}
.oqs-green {
  background: #7f915a;
}
.md-tooltip.oqs-tooltip {
  z-index: 99999 !important;
  height: auto;
  max-width: none;
  width: 470px;
  padding: 10px 12px;
  background: #fff !important;
  color: #333 !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
  border: 1px solid #e0e0e0;
  text-align: left;
  white-space: normal;
}
.oqs-tip-head {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  font-size: 12px;
  color: #666;
}
.oqs-tip-label {
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-size: 11px;
}
.oqs-tip-big {
  font-size: 20px;
  color: #222;
}
.oqs-tip-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}
.oqs-tip-table td {
  padding: 2px 4px;
  white-space: nowrap;
}
.oqs-tip-area td {
  padding-top: 8px;
  font-weight: 600;
  color: #444;
  border-bottom: 1px solid #eee;
}
.oqs-tip-name {
  color: #555;
}
.oqs-tip-value {
  text-align: right;
  color: #333;
}
.oqs-tip-barcell {
  width: 140px;
}
.oqs-tip-barcell {
  display: flex;
  align-items: center;
  gap: 6px;
}
.oqs-tip-score {
  width: 34px;
  text-align: right;
  color: #333;
}
.oqs-tip-num {
  text-align: right;
  color: #333;
}
.oqs-tip-weight {
  color: #999;
}
</style>
